import { render, staticRenderFns } from "./government.vue?vue&type=template&id=e736c4d6&scoped=true"
import script from "./government.vue?vue&type=script&lang=js"
export * from "./government.vue?vue&type=script&lang=js"
import style0 from "./government.vue?vue&type=style&index=0&id=e736c4d6&prod&lang=css"
import style1 from "./government.vue?vue&type=style&index=1&id=e736c4d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e736c4d6",
  null
  
)

export default component.exports